import React, { useEffect, useState } from 'react';
import AdminAwardsCard from './AdminAwardsCard';
import { db } from '../../firebase';
import { collection, getDocs, query } from 'firebase/firestore';
import "../../css/Admin-Awards/AllAwards.css";
import UploadAwards from './UploadAwards';

const AllAwards = () => {
    const [openUploadProject, setOpenUploadProject] = useState(false);
    const [allProjects, setAllProjects] = useState([]);

    async function fetchListings() {
        try {
            const projectRef = collection(db, 'awards');
            const q = query(projectRef);
            const querySnap = await getDocs(q);
            let projects = [];
            querySnap.forEach((doc) => {
                projects.push({
                    id: doc.id,
                    data: doc.data()
                });
            });
            setAllProjects(projects);
            //console.log(projects);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchListings();
    }, []);

    return (
        <div className="all-products-container">
            <div className="header-section">
                <h2 className="page-title">All Awards</h2>
                <button
                    className="upload-button"
                    onClick={() => setOpenUploadProject(true)}
                >
                    Upload Awards
                </button>
            </div>

            <div className="products-list">
                {allProjects.map((project) => (
                    <AdminAwardsCard
                        data={project.data}
                        projectKey={project.id}
                        fetchData={fetchListings}
                    />
                ))}
            </div>

            {/* upload product component */}
            {
                openUploadProject && (
                    <UploadAwards onClose={()=>setOpenUploadProject(false)} fetchData={fetchListings}/>
                )
            }
        </div>
    );
};

export default AllAwards;
